// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-487b4165!./../../../../../node_modules/stylus-loader/index.js!./../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Attachment.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!./../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("42848027", content, false);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-487b4165!./../../../../../node_modules/stylus-loader/index.js!./../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Attachment.vue", function() {
     var newContent = require("!!./../../../../../node_modules/css-loader/index.js?sourceMap!./../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-487b4165!./../../../../../node_modules/stylus-loader/index.js!./../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Attachment.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-487b4165!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/Contact/Contact/Attachment.vue
// module id = 927
// module chunks = 0